import { graphqlLink } from 'config/apolloConfig/index';

export type RefreshTokenResponse = {
  data?: {
    refreshTokens: {
      accessToken: string;
      refreshToken: string;
    };
  };
  errors?: { message: string }[];
};

const fetchRefreshToken = async (
  accessToken: string,
  refreshToken: string,
): Promise<RefreshTokenResponse> => {
  const r = await fetch(graphqlLink, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `JWT ${accessToken}`,
    },
    body: JSON.stringify({
      query: `mutation refreshTokens {refreshTokens(refreshToken: "${refreshToken}") {
                                            accessToken
                                            refreshToken
                                        }}`,
    }),
  });
  return r.json();
};

export default fetchRefreshToken;
